module.exports = __webpack_public_path__ + "static/media/close.04a1f043.svg";